import { render, staticRenderFns } from "./VariantInfo.vue?vue&type=template&id=7cd4eb10"
import script from "./VariantInfo.vue?vue&type=script&lang=js"
export * from "./VariantInfo.vue?vue&type=script&lang=js"
import style0 from "./VariantInfo.vue?vue&type=style&index=0&id=7cd4eb10&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports